<template>
  <el-select
    :value="value"
    :disabled="disabled"
    :clearable="clearable"
    filterable
    placeholder="请选择币种"
    @input="$emit('input', $event)"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    />
  </el-select>
</template>

<script>
import { CUSTOMS_CURRENCY_OPTIONS } from "@/config/constant";

export default {
  name: "CustomsCurrencySelect",
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: CUSTOMS_CURRENCY_OPTIONS
    };
  }
};
</script>
